import { Segment } from '@barstoolsports/web-sdk'

export const segment = new Segment(process.env.NEXT_PUBLIC_SEGMENT_KEY || '')
export default segment
